import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_AURORA } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/hope.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Dreams pt. II — Lost Sky feat. Sara Skinner (NCS). 145 BPM
 * melodic-trap with a clear vocal hook and soft drops. A calm
 * entry-tier track that pairs well with the piano lane vibe.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const HOPE_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'hope',
  baseTitle: 'Dreams pt. II',
  description:
    "Lost Sky's melodic-trap with Sara Skinner's vocal hook. Soft drops and a clear hook — a calm entry-tier track.",
  difficulty: 1,
  totalBeats: 148,
  palette: PALETTE_AURORA,
  audio: buildBuiltinAudio({
    src: '/audio/circles/hope.mp3',
    attribution:
      '"Dreams pt. II (feat. Sara Skinner)" by Lost Sky [NCS Release] - https://ncs.io/Dreams2',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 148,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.05, minSpacing: 0.5 },
    },
  ],
});
